import script from "./JournalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalPage.vue?vue&type=script&setup=true&lang=js"

import "./JournalPage.vue?vue&type=style&index=0&id=3b7c6bfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7c6bfc"]])

export default __exports__